import {Observable} from "rxjs";

export interface IAppInfoService
{
	getAppVersion(): string; // application version (e.g. "x.y.z")

	getBackendVersionObs(): Observable<string>; // back-end version

	getAppShortName(): string; // application short name (e.g. "MyApp")

	getAppName(): string; // application name extended (e.g. "MyApp Application" )

	initStorage(): void; // initialization (if any) of application: session, local, Storages

	provideLogs(): void; // method for providing app logs
}